import styles from './index.module.scss'

export function TaskDetailsSkeleton() {
  return (
    <div className={styles.form}>
      <div className={styles.label} />
      <div className={styles.textRow} />
      <div className={styles.label} />
      <div className={styles.label} />
      <div className={styles.textRow} />
      <div className={styles.label} />
    </div>
  )
}
